import { useHistory } from 'react-router-dom';
import { assertNotNil, navigateToReportLab, navigateToStudioView, useHasFF } from 'venn-utils';
import type { AnalysisView } from 'venn-api';
import { TutorialContent } from './TutorialContent';
import LearnMoreAction from './LearnMoreAction';
import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Button, getAppTitle, GetColor, HOLDINGS_FAQ_HREF } from 'venn-ui-kit';

export const HOLDINGS_TEMPLATE_ID_STUDIO_V2 = '7ae1e402-aea4-4ac2-a844-a756f059059a';
export const HOLDINGS_TEMPLATE_ID_REPORTLAB_V2 = '308f00d3-14dc-4d7f-8523-c26791eabc70';

const HoldingsTab = () => {
  const history = useHistory();
  const hasStudio = useHasFF('studio_ff');
  const hasReportLab = useHasFF('studio_report_editor');
  const { Images } = useContext(ThemeContext);
  const navigateHoldings = () => {
    const id = hasStudio ? HOLDINGS_TEMPLATE_ID_STUDIO_V2 : HOLDINGS_TEMPLATE_ID_REPORTLAB_V2;
    const document = { id, analysisViewType: hasStudio ? 'TEARSHEET' : 'REPORT' } as AnalysisView;
    if (hasStudio) {
      navigateToStudioView(history, { newDocument: document, id });
    } else if (hasReportLab) {
      navigateToReportLab(history, { newDocument: document, id });
    } else {
      window.open(HOLDINGS_FAQ_HREF, '_blank');
    }
  };

  const Headline = () => (
    <>
      <div>
        <New>{`New from ${getAppTitle()}`}</New>: Visualize holdings-based
      </div>
      <div> analytics for geography, asset class,</div>
      <div>and sector breakdowns.</div>
    </>
  );

  return (
    <TutorialContent headline={Headline()} images={[assertNotNil(Images.holdingsAsset)]} hideBorder assetHeight="250px">
      <div>
        <Button dominant onClick={navigateHoldings} className="qa-check-it" data-testid="qa-check-it">
          Check it out
        </Button>
      </div>
      <LearnMoreAction href={HOLDINGS_FAQ_HREF} />
    </TutorialContent>
  );
};

export default HoldingsTab;

const New = styled.div`
  color: ${GetColor.HighlightDark};
  font-weight: bold;
  display: inline-block;
  font-style: italic;
`;
